exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-gallery {\n  flex-wrap: wrap;\n}\n\n.preview {\n  position: relative;\n  width: 80px;\n  height: 80px;\n  margin-left: 1em;\n  margin-bottom: 1em;\n  border-radius: 3px;\n  box-shadow: 1px 1px 1px silver;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.picture {\n  height: auto; \n  width: 160px;\n  margin-left: -10px;\n}\n\n.remove-picture {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  border-radius: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/pictures-viewer/pictures-viewer.component.css
// module id = 861
// module chunks = 0